/**
 * Format a numeric amount as a localized currency string.
 *
 * @param {number|string} amount
 * @param {string} [currency] - defaults to 'USD'
 * @returns {string}
 */
export function formatMoney(amount, currency = 'USD') {
  if (amount === null || amount === undefined || amount === '') {
    return '—';
  }

  const numericValue = Number(amount);
  if (!Number.isFinite(numericValue)) {
    return amount || '—';
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
    }).format(numericValue);
  } catch {
    return `${amount} ${currency}`;
  }
}

/**
 * An offer's billing `period` ({ unit, count } from `/v1/offers`) as the words beside its price:
 * "/month", "/year", " every 3 months". No period on the wire is no words: never guessed from
 * the offer's name.
 *
 * @param {{unit: string, count: number} | null | undefined} period
 * @returns {string}
 */
export function formatPeriod(period) {
  if (!period) {
    return '';
  }
  return period.count === 1 ? `/${period.unit}` : ` every ${period.count} ${period.unit}s`;
}
